"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ResponsiveGridContext = void 0;

var React = _interopRequireWildcard(require("react"));

var _stylingConstants = require("../styling/stylingConstants");

var ResponsiveGridContext = /*#__PURE__*/React.createContext({
  responsiveSteps: [],
  pivot: false,
  row: {
    padding: [_stylingConstants.gridUnit]
  },
  column: {
    padding: [_stylingConstants.gridUnit]
  }
});
exports.ResponsiveGridContext = ResponsiveGridContext;